module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/052-kosovo-bcdb9a17e7dfd09c828c349817d51115.svg";